import { createTheme, outlinedInputClasses, responsiveFontSizes } from "@mui/material";
import { grey } from "@mui/material/colors";

declare module '@mui/material/styles' {
    interface TypographyVariants {
        h7: React.CSSProperties;
    }

    // allow configuration using `createTheme`
    interface TypographyVariantsOptions {
        h7?: React.CSSProperties;
    }
}

// Update the Typography's variant prop options
declare module '@mui/material/Typography' {
    interface TypographyPropsVariantOverrides {
        h7: true;
        // h3: false;
    }
}


let theme = createTheme(
    {
        palette: {
            primary: {
                main: "#182250"
            }
        },
        typography: {
          
        
            // button: {
            //     fontSize: "small",
            //     fontWeight: 500,
            // }
            // ,
            h3: {
                fontSize: 40,
                
            },
            h4: {
                fontWeight: 700
            }, h5: {
                fontWeight: 700
            },
            h6: {
                fontWeight: 700
            },
            h7: {
                fontSize: 15,
                fontWeight: 700,
                lineHeight: 2.5
            },
            body2: {
                lineHeight: 1.5,
                fontSize: 12,
                fontWeight: 400,
                color: "#4A4A50"
            },
            body1: {
                fontSize: 14,
                letterSpacing: "normal",
                fontWeight: "400",
            },
            subtitle1: {
                fontWeight: 400
            }
        },
        components: {
            //region Theme Style fot pagination component
            MuiPagination: {
                styleOverrides: {
                    root: {

                        "& .MuiPaginationItem-root.Mui-selected": {
                            backgroundColor: '#612D78',
                            color: '#FFFFFF',
                            borderColor: "#612D78", "&:hover": {
                                backgroundColor: '#612D78',
                                color: '#FFFFFF',
                                borderColor: "#612D78"
                            }
                        },
                        "& .MuiPaginationItem-root": {
                            backgroundColor: 'white',
                            color: "#000000",
                            borderColor: "#E1E1E1",
                            fontSize: "small",
                            fontWeight: 700,
                            "&:hover": {
                                backgroundColor: '#612D78',
                                color: '#FFFFFF',
                                borderColor: "#612D78"
                            }
                        },
                    }
                }
            }
            //endregion
            //region Switch Styling
            , MuiSwitch: {
                styleOverrides: {
                    root: {
                        width: 42,
                        height: 26,
                        padding: 0,
                        '& .MuiSwitch-switchBase': {
                            padding: 0,
                            margin: 2,
                            transitionDuration: '300ms',
                            '&.Mui-checked': {
                                transform: 'translateX(16px)',
                                color: '#fff',
                                '& + .MuiSwitch-track': {
                                    backgroundColor: '#65C466',
                                    opacity: 1,
                                    border: 0,
                                },
                                '&.Mui-disabled + .MuiSwitch-track': {
                                    opacity: 0.5,
                                },
                            },
                            '&.Mui-focusVisible .MuiSwitch-thumb': {
                                color: '#33cf4d',
                                border: '6px solid #fff',
                            },
                            '&.Mui-disabled .MuiSwitch-thumb': {
                                color:
                                    grey[100]
                            },
                            '&.Mui-disabled + .MuiSwitch-track': {
                                opacity: 0.7,
                            },
                        },
                        '& .MuiSwitch-thumb': {
                            boxSizing: 'border-box',
                            width: 22,
                            height: 22,
                        },
                        '& .MuiSwitch-track': {
                            borderRadius: 26 / 2,
                            backgroundColor: '#E9E9EA',
                            opacity: 1,
                            // transition: transitions.create(['background-color'], {
                            //     duration: 500,
                            // }),
                            

                        }
                    }
                }
            }
            //endregion
            //region Styles for MUI button
            , MuiButton: {
                styleOverrides: {
                    root: {
                        overflow: "hidden",
                        transitionProperty: "color, background-color, border-color, text-decoration-color, fill, stroke",
                        transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
                        transitionDuration: ["300ms", "500ms"],

                        paddingLeft: 25,
                        paddingRight: 25,
                        textTransform: "none",
                        width: "100%",
                        minWidth: 0,
                        fontWeight: "700",
                        // fontSize:".7rem",
                        color: "white",
                        ":disabled": {
                            background: "#E5E5E5 !important",
                            color: "#B0B0B0 !important",
                        },
                        borderRadius: 5,
                        // margin: 2
                    }
                }
            },
            //endregion
            //region Style Input
            MuiInputBase: {
                styleOverrides: {
                    multiline: {
                        height: "auto !important"
                    },
                }
            },
            MuiFormHelperText: {
                styleOverrides: {
                    root: {
                        color: "rgba(0, 0, 0, 0.6)",
                        fontFamily: "Roboto",
                        fontWeight: 400,
                        fontSize: "0.7rem",
                        lineHeight: 1.66,
                        textAlign: "left",
                        marginTop: "0px",
                        marginRight: "14px",
                        marginBottom: 0,
                        marginLeft: 0,
                    }
                }
            }
            , MuiOutlinedInput: {
                styleOverrides: {
                    root: {

                        [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
                            borderColor: '#182250',
                        },
                        [`&.Mui-disabled .${outlinedInputClasses.notchedOutline}`]: {
                            borderColor: '#182250',
                        },
                        "&.Mui-disabled": {
                            backgroundColor: "none",
                        }
                        // [`&.Mui-focused .${outlinedInputClasses.notchedOutline}`]: {
                        //     borderColor: '#602C77',
                        // },
                    },
                }
            },
            MuiFormLabel: {
                styleOverrides: {
                    root: {
                        // "&.Mui-focused": {
                        //     color: "#602C77",
                        //     fontWeight: "700"
                        // }
                    }
                }
            }
            //endregion
            , MuiTypography: {
                defaultProps: {
                    variantMapping: {
                        // Map the new variant to render a <h1> by default
                        h7: 'h6',
                    },
                },
            },

        }
    }
)


theme = createTheme(theme, {
    components: {
        MuiInputLabel: {
            styleOverrides: {
                shrink: {
                    top: "2px !important"
                },
                root: {
                    [theme.breakpoints.up('xs')]: {
                        top: "-5px",
                        fontSize: ".7rem"
                    },
                    [theme.breakpoints.up('sm')]: {
                        top: "-4px",
                        fontSize: ".75rem"
                    },
                    [theme.breakpoints.up('md')]: {
                        top: "-3px",
                        fontSize: ".8rem"
                    },
                    [theme.breakpoints.up('lg')]: {
                        top: "-2px",
                        fontSize: ".85rem"
                    },
                    [theme.breakpoints.up('xl')]: {
                        top: "-1px",
                        fontSize: ".9rem"
                    },
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    [theme.breakpoints.up('xs')]: {
                        height: 40,
                    },
                    [theme.breakpoints.up('sm')]: {
                        height: 43,
                    },
                    [theme.breakpoints.up('md')]: {
                        height: 45,
                    },
                    [theme.breakpoints.up('lg')]: {
                        height: 47,
                    },
                    [theme.breakpoints.up('xl')]: {
                        height: 40,
                    },
                }
            }
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    [theme.breakpoints.up('xs')]: {
                        maxHeight: 30,
                        height: 30,
                        minHeight: 30,
                        fontSize: ".7rem"
                    },
                    [theme.breakpoints.up('sm')]: {
                        maxHeight: 32,
                        height: 32,
                        minHeight: 32,
                        fontSize: ".75rem"
                    },
                    [theme.breakpoints.up('md')]: {
                        maxHeight: 34,
                        height: 34,
                        minHeight: 34,
                        fontSize: ".8rem"
                    },
                    [theme.breakpoints.up('lg')]: {
                        maxHeight: 36,
                        height: 36,
                        minHeight: 36,
                        fontSize: ".85rem"
                    },
                    [theme.breakpoints.up('xl')]: {
                        maxHeight: 38,
                        height: 38,
                        minHeight: 38,
                        fontSize: ".9rem"
                    },
                }
            }
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    [theme.breakpoints.up('xs')]: {
                        height: 40,
                        fontSize: ".7rem"
                    },
                    [theme.breakpoints.up('sm')]: {
                        height: 43,
                        fontSize: ".75rem"
                    },
                    [theme.breakpoints.up('md')]: {
                        height: 45,
                        fontSize: ".8rem"
                    },
                    [theme.breakpoints.up('lg')]: {
                        height: 47,
                        fontSize: ".85rem"
                    },
                    [theme.breakpoints.up('xl')]: {
                        height: 50,
                        fontSize: ".9rem"
                    },
                },

            }
        }
    }
})

const resposiveTheme = responsiveFontSizes(theme)


export default resposiveTheme

